import { FlattenedAnnotation } from './validateAnnotation';
import { templateService } from '@/service/template';

export interface TemplateData {
  pdf?: string;
  name: string;
  setting: TemplateSetting;
  created?: Date;
  updated?: Date;
  annotations?: FlattenedAnnotation[];
  appId?: any;
  recordId?: any;

  [key: string]: string | Date | TemplateSetting | undefined | any[];
}

export interface TemplateSetting {
  uri?: string;
  'enable-page-break': boolean;
  'kintone_data': boolean;
  'app_id'?: any;
  'field_key'?: any;
}

interface ResultAddTemplate {
  slug?: string;
  error?: string;
  validationErrors?: {
    message: string;
    page: number;
    annotation: string;
  }[];
  totalAnnotations?: number;
  totalErrors?: number;
}

export class Template {
  constructor(private orgSlug: string, private prjSlug?: string, private slug?: string) {
  }

  async all(): Promise<TemplateData[] | undefined> {
    try {
      return await templateService.getAll(`${this.orgSlug}`, `${this.prjSlug}`);
    } catch (e) {
      console.warn(e);
      return;
    }
  }

  async get(): Promise<TemplateData | undefined> {
    try {
      if (!this.slug) throw new Error('Slug is required');
      return await templateService.getOne(`${this.orgSlug}`, `${this.prjSlug}`, `${this.slug}`);
    } catch (e) {
      console.warn(e);
      return;
    }
  }

  async add(template: TemplateData): Promise<ResultAddTemplate> {
    try {
      const res = await templateService.add(`${this.orgSlug}`, `${this.prjSlug}`, template);
      return { slug: res.slug };
    } catch (e: any) {
      console.warn(e);
      return {
        error: e.message,
        validationErrors: e.validationErrors || [],
        totalAnnotations: e.totalAnnotations || 0,
        totalErrors: e.totalErrors || 0,
      };
    }
  }

  async update(template: TemplateData): Promise<any> {
    try {
      if (!this.slug) throw new Error('Slug is required');
      const res = await templateService.update(`${this.orgSlug}`, `${this.prjSlug}`, `${this.slug}`, template);
      return { slug: res.slug };
    } catch (e: any) {
      console.warn(e);
      return {
        error: e.message,
        validationErrors: e.validationErrors || [],
        totalAnnotations: e.totalAnnotations || 0,
        totalErrors: e.totalErrors || 0,
      };
    }
  }

  async delete(): Promise<boolean> {
    try {
      if (!this.slug) throw new Error('Slug is required');
      return await templateService.delete(`${this.orgSlug}`, `${this.prjSlug}`, `${this.slug}`);
    } catch (e) {
      console.warn(e);
      return false;
    }
  }
}
